export default __webpack_public_path__ + "52142eacc9d053ef4feb7190212c4893.svg";